export const SITE_ORIGIN = 'https://escribonauta.cl'
export const SITE_NAME = 'Escribonauta'
export const DEFAULT_OG_IMAGE = `${SITE_ORIGIN}/og-image.png`

export function absoluteUrl(path: string): string {
  if (path.startsWith('http')) {
    return path
  }
  const normalized = path.startsWith('/') ? path : `/${path}`
  return `${SITE_ORIGIN}${normalized}`
}
